import React, { PropsWithChildren } from "react";
import { BASE_CLASS, CustomizeExperienceStatus } from "./customize-experience";
import Loader from "atoms/loaders/loader";
import { LoaderStyles } from "atoms/constants/loader-styles";
import Button from "atoms/buttons/button";
import { t } from "utilities/localization-utils";
import { ButtonStyles } from "atoms/constants/button-styles";
import CustomizeExperienceHeader from "./customize-experience-header";

interface CustomizeExperienceSectionProps extends PropsWithChildren {
    heading: string;
    subheading: string;
    stage: CustomizeExperienceStatus;
    isLoading: boolean;
    onContinueClick: () => void;
    onBackClick?: () => void;
    showBackButton?: boolean;
    showContinueButton?: boolean;
    disableContinueButton: boolean;
}

const CustomizeExperienceSection = ({
    heading,
    subheading,
    stage,
    isLoading,
    onContinueClick,
    onBackClick,
    showBackButton = false,
    showContinueButton = true,
    disableContinueButton = false,
    children,
}: CustomizeExperienceSectionProps) => {
    return (
        <>
            <CustomizeExperienceIndicatorDots activeDot={stage} />
            <CustomizeExperienceHeader
                heading={heading}
                subheading={subheading}
            />
            {children}
            <footer className={`${BASE_CLASS}__button-container`}>
                {isLoading ? (
                    <Loader type={LoaderStyles.LinkGlyphGray} />
                ) : (
                    <>
                        {showBackButton && (
                            <Button
                                cssClassName={`${BASE_CLASS}__back-button`}
                                style={ButtonStyles.Tertiary}
                                disabled={disableContinueButton}
                                onClick={onBackClick}>
                                {t("back")}
                            </Button>
                        )}
                        {showContinueButton && (
                            <Button
                                cssClassName={`${BASE_CLASS}__continue-button`}
                                disabled={disableContinueButton}
                                onClick={onContinueClick}>
                                {t("continue")}
                            </Button>
                        )}
                    </>
                )}
            </footer>
        </>
    );
};

export const CustomizeExperienceIndicatorDots = ({ activeDot }) => {
    return (
        <div className={`${BASE_CLASS}__dots-container`}>
            {Object.values(CustomizeExperienceStatus)
                .filter((key) => !isNaN(Number(key)))
                .map((status) => (
                    <div
                        className={`${BASE_CLASS}__dot ${activeDot === status ? "-active" : ""}`}
                    />
                ))}
        </div>
    );
};

export default CustomizeExperienceSection;
